import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useTasksStore = defineStore('tasks', {
  state,
  getters,
  actions
})

export default useTasksStore
